import React, { Component } from 'react';
import Ionicon from 'react-ionicons';
import Typist from 'react-typist';
import scrollToElement from 'scroll-to-element';

class Intro extends Component {
  handleArrowClick(el) {
    scrollToElement(el);
  }

  render() {
    return (
      <div className="jumbotron">
        <div className="intro container">
          <div className="row">
            <div className="col-md-offset-3 col-md-6 col-sm-12">
              <h2 className="sans">
                <Typist startDelay={300} avgTypingDelay={70}>
                  <strong>&lt;Jeff Comer /&gt;</strong>
                </Typist>
              </h2>
              <h2 className="mono">
                <Typist startDelay={1500} avgTypingDelay={90}>
                  <span className="purple">Full-stack</span> <span className="pink">Developer</span>
                </Typist>
                <br />
              </h2>
              <hr />
              <Typist startDelay={4000} avgTypingDelay={70}>
                <blockquote>
                  I am <span className="highlight">passionate</span> about creating applications
                  that are <span className="highlight">useful</span> and{' '}
                  <span className="highlight">fun</span> to use.
                </blockquote>
              </Typist>
              <div className="text-center more">
                <span className="arrow" onClick={() => this.handleArrowClick('#about')}>
                  <Ionicon icon="ion-ios-arrow-down" fontSize="25px" color="white" />
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default Intro;



// WEBPACK FOOTER //
// ./src/components/intro.js